import React, { useState, useEffect } from 'react';
import { Typography, Grid, Paper, Button, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { useNavigate, useParams } from 'react-router';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { getApi } from 'views/services/api';

const InvoiceDetails = ({ value }) => (
  <Typography variant="subtitle1">{value}</Typography>
);

const InvoiceTable = ({ items }) => (
  <TableContainer component={Paper} sx={{marginY : 2}}>
    <Table sx={{ minWidth: 650 }}>
      <TableHead>
        <TableRow>
          <TableCell><b>Description</b></TableCell>
          <TableCell><b>Price</b></TableCell>
          <TableCell><b>Quantity</b></TableCell>
          <TableCell><b>Amount</b></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {items.map((item) => (
          <TableRow key={item._id}>
            <TableCell><b>{item.name}</b></TableCell>
            <TableCell>{item.price}</TableCell>
            <TableCell>{item.quantity}</TableCell>
            <TableCell>Rs {item.price * item.quantity}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

const SeparateFoodInvView = () => {
  const [invoiceData, setInvoiceData] = useState({});
  const [isPrinted, setIsPrinted] = useState(false);
  const hotel = JSON.parse(localStorage.getItem('hotelData'));
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchInvoiceData = async () => {
      try {
        const response = await getApi(`api/separatefoodinvoice/viewspecificinvoice/${id}`);
        setInvoiceData(response?.data?.InvoiceData);
      } catch (error) {
        console.error(error);
      }
    };
    fetchInvoiceData();
  }, [id]);

  const handlePrint = () => {
    setIsPrinted(true);
    window.print();
  };

  const currentDate = new Date().toLocaleDateString();

  return (
    <Grid container justifyContent="center" sx={{ padding: '20px' }}>
      <Grid item xs={12}>
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          sx={{ marginLeft: 2, color: '#673ab7', borderColor: '#673ab7', position: 'absolute', right: 10 }}
          onClick={() => navigate(-1)}
          className={`back-button ${isPrinted ? 'hidden' : ''}`}
        >
          Back
        </Button>
      </Grid>

      <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
        <Paper elevation={2} sx={{ padding: '20px', maxWidth: '800px', marginTop: '12px' }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h3" align="center" gutterBottom>
                Restaurant Invoice
              </Typography>
              <Typography variant="subtitle1" align="center" gutterBottom>
                Date: {currentDate}
              </Typography>
              <Divider />
            </Grid>

            <Grid item xs={12} md={4} >
              <Typography variant="h4" gutterBottom>
                Hotel Details
              </Typography>
              <InvoiceDetails   value={hotel.name} />
              <InvoiceDetails  value={hotel.address} />

              <br/>
              <Typography variant="h4" gutterBottom>
                Customer Details
              </Typography>
              <InvoiceDetails value={invoiceData?.name} />
              <InvoiceDetails value={invoiceData?.address} />
              <InvoiceDetails value={invoiceData?.customerPhoneNumber} />
            </Grid>

            <Grid item xs={12} md={4}>
              <Typography variant="h4">Invoice Number</Typography> 
              <Typography variant="subtitle1">{invoiceData?.invoiceNumber}</Typography> 
              <br/>

              <Typography variant="h4">GST Number</Typography> 
              <Typography variant="subtitle1">{invoiceData?.gstNumber}</Typography>    
            </Grid>

            <Grid item xs={12} md={4}>
              <Typography variant="h4">Payment Method</Typography> 
              <Typography variant="subtitle1">{invoiceData?.paymentMethod}</Typography>    
            </Grid>

            <Grid item xs={12}>
              <InvoiceTable items={invoiceData?.foodItems || []} />
            </Grid>

            <Grid item xs={12} sx={{ marginTop: '20px' }}>
              <Divider />
              <Typography sx={{ textAlign: 'left', marginTop: '20px' }}>
                <b>Discount:</b> Rs {invoiceData?.discount || 0}
              </Typography>
              {invoiceData?.haveGST && (
                <Typography sx={{ textAlign: 'left', marginTop: '10px' }}>
                  <b>GST Amount:</b> Rs {invoiceData?.gstAmount}
                </Typography>
              )}
              {invoiceData?.totalAmount && (
                <Typography sx={{ textAlign: 'left', marginTop: '10px' }}>
                  <b>Total Amount {invoiceData?.haveGST ? '(with GST)' : ''}:</b> Rs {invoiceData?.totalAmount}
                </Typography>
              )}
            </Grid>

            <Grid item xs={12} sx={{ textAlign: 'end', marginTop: '20px' }}>
              <Typography sx={{ fontSize: '15px' }} variant="subtitle1">
                Signature
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      </Grid>

      <style>
        {`
          @media print {
            .print-button,
            .back-button.hidden {
              display: none;
            }
          }
        `}
      </style>

      <Grid item xs={12} sx={{ marginTop: '20px', display: 'flex', justifyContent: 'center' }} className="print-button">
        <Button variant="contained" onClick={handlePrint}>
          Print
        </Button>
      </Grid>
    </Grid>
  );
};

export default SeparateFoodInvView;

